export default __webpack_public_path__ + "static/media/location.ba062eac.svg";